<template>
<div class="flex flex-row">
  <div class="flex flex-col lg:flex-row w-full justify-end items-center relative">
    <nav class="flex items-start lg:w-1/3 w-11/12 justify-between z-20 pr-7">
      <button class="flex flex-row mt-10 hoverSvg" onclick="history.back()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-5 rotate-90"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M447.1 256C447.1 273.7 433.7 288 416 288H109.3l105.4 105.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H416C433.7 224 447.1 238.3 447.1 256z"/></svg>
      </button>
      <router-link :to="dashboardPath">
        <img :src="profilePic ? profilePic : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png'"
        class="rounded-full border-2 w-8 lg:w-11 my-7"
        :class="$route.fullPath === dashboardPath
        ? 'border-'+textColor : 'hover:border-'+textColor">
      </router-link>
      <div class='has-tooltip my-8 w-8'>
        <span class='tooltip'>
          {{$t('dashboard.calendar')}}
        </span>
        <router-link :to="dashboardPath+'/calendar'">
          <calendar-icon
          :class="$route.fullPath === dashboardPath+'/calendar' ?
          'text-'+textColor : 'hover:text-'+textColor" />
        </router-link>
      </div>
      <div class='has-tooltip my-8 w-8'>
        <span class='tooltip'> {{$t('lesson.classrooms')}}</span>
        <router-link :to="dashboardPath+'/classrooms'">
          <classroom-icon
          :class="$route.fullPath === dashboardPath+'/classrooms' ?
          'text-'+textColor : 'hover:text-'+textColor" />
        </router-link>
      </div>
      <div class='has-tooltip my-8 w-8'>
        <span class='tooltip'> Masterclasses</span>
        <router-link :to="dashboardPath+'/masterclasses'">
          <masterclass-icon
          :class="$route.fullPath === dashboardPath+'/masterclasses' ?
          'text-'+textColor : 'hover:text-'+textColor" />
        </router-link>
      </div>
      <div class='has-tooltip my-8 w-8'>
        <span class='tooltip'> Settings</span>
        <router-link :to="dashboardPath+'/profile'">
            <settings-icon :class="$route.fullPath === dashboardPath+'/profile' ?
            'text-'+textColor : 'hover:text-'+textColor"/>
        </router-link>
      </div>
    </nav>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CalendarIcon from './CalendarIcon.vue';
import SettingsIcon from './SettingsIcon.vue';
import MasterclassIcon from './MasterclassIcon.vue';
import ClassroomIcon from './ClassroomIcon.vue';

export default {
  props: ['profilePic'],

  data() {
    return {
    };
  },

  components: {
    CalendarIcon,
    SettingsIcon,
    ClassroomIcon,
    MasterclassIcon,
  },

  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),

    textColor() {
      if (this.isTeacher) {
        return 'beige-academy-300';
      }
      return 'indigo-500';
    },
  },
};
</script>

<style>
  .tooltip {
    @apply invisible absolute text-gray-500 text-xs mt-10 font-sans-serif;
  }

  .has-tooltip:hover .tooltip {
    @apply visible z-50;
  }
  .hoverSvg
    :hover {
      fill: #93162f;
    }
</style>
